import { ORDER_META_KEY } from "../constants.js";
import { getMetaValueFromKey } from "@cappelendamm/crystallize-utils";
export const getOrderType = (order) => {
    return getMetaValueFromKey(order.meta, ORDER_META_KEY.ORDER.ORDER_TYPE);
};
